import { User } from '@domain/user/user';
import { Role } from '@domain/user/role';
import { UserResponseDto } from '@infrastructure/api/dtos/user/user.response.dto';
import { RoleResponseDto } from '@infrastructure/api/dtos/role/role.response.dto';
import { UserRequestDto } from '@infrastructure/api/dtos/user/user.request.dto';

export class UserMapper {
  static toDomain(dto: UserResponseDto): User {
    return new User(
      dto.id,
      dto.username,
      dto.email,
      dto.active,
      new Role(dto.role.id, dto.role.role),
    );
  }

  static toDomainList(dtos: UserResponseDto[]): User[] {
    return dtos.map(UserMapper.toDomain);
  }

  static toRequestDto(entity: User): UserRequestDto {
    const roleDto: RoleResponseDto = { id: entity.role.id!, role: entity.role.role };
    const dto: UserRequestDto = {
      username: entity.username,
      email: entity.email,
      active: entity.active,
      role: roleDto,
    };
    if (entity.password) {
      dto.password = entity.password;
    }
    return dto;
  }
}
